function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M0,0H24V24H0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12,18.8999A11.38087,11.38087,0,0,1,1.644,12.20557L1.55176,12l.09228-.20557a11.357,11.357,0,0,1,20.71192.001l.09228.20508-.09277.20508A11.38123,11.38123,0,0,1,12,18.8999ZM2.65137,12a10.35679,10.35679,0,0,0,18.69775-.00049A10.35716,10.35716,0,0,0,2.65137,12Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12,16.17578A4.17578,4.17578,0,1,1,16.17578,12,4.18067,4.18067,0,0,1,12,16.17578Zm0-7.35156A3.17578,3.17578,0,1,0,15.17578,12,3.17968,3.17968,0,0,0,12,8.82422Z"
});

var SvgIVisibilityOutline = function SvgIVisibilityOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIVisibilityOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_visibility_outline.ea8987a4.svg";
export { ForwardRef as ReactComponent };